import React, { useCallback, useEffect, useState } from "react";

import { getAllFields, getFieldShapeAdmin } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, Col, Form, MainPage, Option, Row, Select, TagNormal } from "components";

import { CropMap } from "pages/admin/verifications/CropMap";

export const Visualisations = () => {
  const [fields, setFields] = useState([]);
  const [location, setLocation] = useState(false);
  const [geometry, setGeometry] = useState(false);
  const [field, setField] = useState({ size: 0 });
  const [page, setPage] = useState(0);

  const signal = useCancelAsyncOnUnmount()();

  const loadAllFields = useCallback(() => {
    getAllFields({
      page,
      signal,
    }).then((res) => {
      setFields((fields) => [...fields, ...res.fields]);
      if (res.count > page * 250 && res.count > 250) {
        setPage(page + 1);
      }
    });
  }, [page, signal]);

  const updateField = (v) => {
    const field = fields[v];

    setGeometry(false);
    setField(field);
    setLocation(field.location);

    getFieldShapeAdmin({
      fieldId: field.id,
      signal,
    }).then((res) => {
      if (res.fieldShape) {
        setGeometry(res.fieldShape);
      }
    });
  };

  useEffect(() => {
    loadAllFields();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage pageName={"admin"}>
      <AdminHead
        headline={
          <>
            Crop visualisations <TagNormal text="ALPHA" style={{ transform: "translate(0, -50%)", fontWeight: "bold" }} />
          </>
        }
        description={
          <>
            Choose a field to map below (only the first 250 fields are retrieved for this experiment) - nothing will be shown if the field geometry is not
            available. You can then visualize crop growths and other data over time.
            <br />
            <br />
            <b>In production, maps should be bounded to the specific field so users can't browse the whole earth.</b>
          </>
        }
      />
      <div className="content">
        <Row>
          <Col sm={24} md={12}>
            <Form>
              <Select
                name="field"
                label="Select field"
                rules={[{ required: true }]}
                style={{ width: "100%" }}
                showSearch
                filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={(v) => updateField(v)}
                optionLabelProp={"label"}
              >
                {fields.map((field, i) => {
                  if (field.location) {
                    return (
                      <Option value={i} key={i} label={field.name}>
                        {field.name}
                        <br />
                        <small>{field.farmName}</small>
                      </Option>
                    );
                  }
                  return null;
                })}
              </Select>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col sm={24} md={12}>
            <CropMap field={field} geometry={geometry} location={location} />
          </Col>
          <Col sm={24} md={12}>
            <CropMap field={field} geometry={geometry} location={location} />
          </Col>
        </Row>
      </div>
    </MainPage>
  );
};
